// Import tippy.js and styles
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

// Age
tippy("#tooltipAge", {
  content: "How old are you now? This helps us calculate your estimated age at retirement.",
  placement: 'auto',
  maxWidth: 270,
});

// Debt
tippy("#tooltipDebt", {
  content: "How much debt do you have from any source? This helps us determine how much you need to save before retirement.",
  placement: 'auto',
  maxWidth: 270,
});

// Annual Income
tippy("#tooltipIncome", {
  content: "How much do you make each year after taxes? This helps us calculate your retirement contribution rate.",
  placement: 'auto',
  maxWidth: 270,
});

// Current Portfolio
tippy("#tooltipPortfolio", {
  content: "How much do you already have saved for retirement? This helps us establish a baseline for your future investments.",
  placement: 'auto',
  maxWidth: 270,
});

// Current Retirement Contributions
tippy("#tooltipContributions", {
  content: "How much do you invest each year toward retirement? This help us calculate your retirement contribution rate.",
  placement: 'auto',
  maxWidth: 270,
});

// Annual Retirement Spending
tippy("#tooltipSpending", {
  content: "How much will you spend each year during retirement in today’s dollars? This helps us determine what you need to save for retirement.",
  placement: 'auto',
  maxWidth: 270,
});
